'use client'

import { Bookmark, ExternalLink } from 'lucide-react'
import { useBookmarks } from '@/stores/useBookmarks'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function DashboardBookmarks() {
  const { bookmarks } = useBookmarks()

  // 如果没有书签，不显示组件
  if (bookmarks.length === 0) {
    return null
  }

  // 处理书签点击
  const handleBookmarkClick = (url: string) => {
    if (typeof window !== 'undefined') {
      window.location.href = `/${url}`
    }
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2">
          <Bookmark className="h-5 w-5 text-yellow-500" />
          我的書籤
          <Badge variant="secondary" className="ml-2">
            {bookmarks.length}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {bookmarks.map((bookmark, index) => (
            <div
              key={`${bookmark.key}-${bookmark.url}-${index}`}
              className="h-auto p-4 border rounded-lg hover:bg-primary/5 transition-colors cursor-pointer"
              onClick={() => handleBookmarkClick(bookmark.url)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleBookmarkClick(bookmark.url)
                }
              }}
            >
              <div className="flex items-center gap-3 w-full">
                <div className="flex-shrink-0">
                  <ExternalLink className="h-4 w-4 text-muted-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{bookmark.name}</div>
                  <div className="text-xs text-muted-foreground truncate mt-1">{bookmark.url}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
